module.exports = __webpack_public_path__ + "img/ollanta-humala.d7e059fa.png";